import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const CancelIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M9.74406 1.49296L6.23815 4.99964L9.74406 8.50777C10.0853 8.84764 10.0853 9.40194 9.74406 9.74327C9.57343 9.91394 9.34884 10 9.12425 10C8.90258 10 8.67799 9.91394 8.50591 9.74327L5 6.2366L1.49409 9.74327C1.32347 9.91394 1.09742 10 0.875747 10C0.651159 10 0.426571 9.91394 0.255943 9.74327C-0.0853143 9.40194 -0.0853143 8.84764 0.255943 8.50777L3.76185 4.99964L0.255943 1.49296C-0.0853143 1.15309 -0.0853143 0.598789 0.255943 0.255999C0.598658 -0.085333 1.15138 -0.085333 1.49409 0.255999L5 3.76267L8.50591 0.255999C8.85008 -0.085333 9.40426 -0.0838743 9.74406 0.255999C10.0853 0.598789 10.0853 1.15309 9.74406 1.49296"
    />
  </svg>
);

CancelIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CancelIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(10, 10),
};

export default CancelIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/cancel.js